import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import WhatMakesDifferent from '../components/WhatMakesDifferent';
import About from '../components/About';
import SatisfactionGuarantee from '../components/SatisfactionGuarantee';
import Guarantee from '../components/Guarantee';
import CTA from '../components/CTA';

const HomePage = () => {
  useEffect(() => {
    document.title = "Snap Launch Studio | Web Design & Automation for Small Businesses";
  }, []);

  return (
    <>
      <Hero />
      <Services />
      <WhatMakesDifferent />
      <About />
      <SatisfactionGuarantee />
      <Guarantee />
      <CTA />
    </>
  );
};

export default HomePage;
